import FileHandler from './FileHandler';

export default FileHandler;



// WEBPACK FOOTER //
// ./src/components/FileHandler/index.js